import { onScopeDispose } from 'vue'
import gsap from '../utils/gsap'

// Returns a factory that creates GSAP timelines owned by the calling component.
// Must be called synchronously in setup(), so cleanup is registered on the
// component's scope. The returned factory can then be called at any time
// (after awaits, inside watchers, inside emitted factories) and every timeline
// it creates is killed when the component unmounts.
export default function useGsapTimeline() {
  const timelines = []

  onScopeDispose(() => timelines.forEach((timeline) => timeline.kill()))

  return (options = {}) => {
    const timeline = gsap.timeline(options)
    timelines.push(timeline)

    if ('name' in options) {
      useDebugStore().add(options.name, timeline)
    }

    return timeline
  }
}
